function ModuleAccessDenied({ moduleLabel }) {
  return (
    <div className="crm-panel mx-auto max-w-xl p-8 text-center">
      <h2 className="text-xl font-semibold text-[rgb(var(--crm-text))]">Access denied</h2>
      <p className="crm-text-muted mt-3 text-sm leading-relaxed">
        You do not have permission to open
        {moduleLabel ? ` “${moduleLabel}”` : ' this section'}. Contact your admin if you need
        access.
      </p>
    </div>
  );
}

export default ModuleAccessDenied;
